export default {
    drawer: 1300,
    modal: 1400,
    toast: 1500,
    tooltip: 1600
};
